import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["aria-labelledby"]
const _hoisted_2 = {
  key: 0,
  class: "mb-8",
  "data-cy": "choose-dressing-party-options"
}
const _hoisted_3 = { class: "pl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_radiolist = _resolveComponent("radiolist")!
  const _component_checklist = _resolveComponent("checklist")!
  const _component_toppingModal = _resolveComponent("toppingModal")!

  return (_openBlock(), _createElementBlock("div", {
    "aria-labelledby": _ctx.partyOptions.name,
    "data-cy": "salad-toppings",
    class: "salad-toppings"
  }, [
    _createVNode(_component_ion_card_title, {
      class: "mx-8 mb-8 ion-text-center bold",
      "data-cy": "choose-dressing-title"
    }, {
      default: _withCtx(() => _cache[4] || (_cache[4] = [
        _createTextVNode("Choose Your Dressing")
      ])),
      _: 1
    }),
    (_ctx.selectedSize?.isPartySize)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_radiolist, {
            options: _ctx.partyOptions,
            keyName: "name",
            dense: "",
            modelValue: _ctx.selectedPartyOption,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedPartyOption) = $event)),
            class: "mb-8"
          }, null, 8, ["options", "modelValue"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (!_ctx.selectedSize?.isPartySize || _ctx.selectedPartyOption == _ctx.partyOptions[1])
        ? (_openBlock(), _createBlock(_component_checklist, {
            key: 0,
            "aria-labelledby": _ctx.localDressing,
            items: _ctx.filteredLocalDressing,
            onUpdate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.localDressing = $event)),
            onlyQuantity: "",
            "data-cy": "choose-dressing-checklist",
            class: "mb-button",
            onLimit: _ctx.limits
          }, null, 8, ["aria-labelledby", "items", "onLimit"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.localToppings)
      ? (_openBlock(), _createBlock(_component_toppingModal, {
          key: 1,
          showToppingPreview: "",
          btnName: "Customize",
          onUpdate: _cache[2] || (_cache[2] = ($event: any) => (_ctx.localToppings = $event)),
          availableTopping: _ctx.availableTopping,
          toppings: _ctx.localToppings,
          "onUpdate:toppings": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localToppings) = $event)),
          hideSplitOpts: ""
        }, null, 8, ["availableTopping", "toppings"]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}